/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SoftwareRequirement } from "./SoftwareRequirement";
import {
  SoftwareRequirementFromJSON,
  SoftwareRequirementFromJSONTyped,
  SoftwareRequirementToJSON,
  SoftwareRequirementToJSONTyped,
} from "./SoftwareRequirement";
import type { SoftwareAudienceTeam } from "./SoftwareAudienceTeam";
import {
  SoftwareAudienceTeamFromJSON,
  SoftwareAudienceTeamFromJSONTyped,
  SoftwareAudienceTeamToJSON,
  SoftwareAudienceTeamToJSONTyped,
} from "./SoftwareAudienceTeam";

/**
 *
 * @export
 * @interface SoftwareSummary
 */
export interface SoftwareSummary {
  /**
   *
   * @type {string}
   * @memberof SoftwareSummary
   */
  softwareId: string;
  /**
   *
   * @type {string}
   * @memberof SoftwareSummary
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SoftwareSummary
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof SoftwareSummary
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof SoftwareSummary
   */
  iconSlug?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SoftwareSummary
   */
  managedInEntra: boolean;
  /**
   *
   * @type {string}
   * @memberof SoftwareSummary
   */
  managementUrl?: string | null;
  /**
   *
   * @type {SoftwareRequirement}
   * @memberof SoftwareSummary
   */
  requirement: SoftwareRequirement;
  /**
   *
   * @type {Array<SoftwareAudienceTeam>}
   * @memberof SoftwareSummary
   */
  requiredTeams: Array<SoftwareAudienceTeam>;
}

/**
 * Check if a given object implements the SoftwareSummary interface.
 */
export function instanceOfSoftwareSummary(
  value: object,
): value is SoftwareSummary {
  if (!("softwareId" in value) || value["softwareId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("managedInEntra" in value) || value["managedInEntra"] === undefined)
    return false;
  if (!("requirement" in value) || value["requirement"] === undefined)
    return false;
  if (!("requiredTeams" in value) || value["requiredTeams"] === undefined)
    return false;
  return true;
}

export function SoftwareSummaryFromJSON(json: any): SoftwareSummary {
  return SoftwareSummaryFromJSONTyped(json, false);
}

export function SoftwareSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SoftwareSummary {
  if (json == null) {
    return json;
  }
  return {
    softwareId: json["softwareId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    url: json["url"] == null ? undefined : json["url"],
    iconSlug: json["iconSlug"] == null ? undefined : json["iconSlug"],
    managedInEntra: json["managedInEntra"],
    managementUrl:
      json["managementUrl"] == null ? undefined : json["managementUrl"],
    requirement: SoftwareRequirementFromJSON(json["requirement"]),
    requiredTeams: (json["requiredTeams"] as Array<any>).map(
      SoftwareAudienceTeamFromJSON,
    ),
  };
}

export function SoftwareSummaryToJSON(json: any): SoftwareSummary {
  return SoftwareSummaryToJSONTyped(json, false);
}

export function SoftwareSummaryToJSONTyped(
  value?: SoftwareSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    softwareId: value["softwareId"],
    name: value["name"],
    description: value["description"],
    url: value["url"],
    iconSlug: value["iconSlug"],
    managedInEntra: value["managedInEntra"],
    managementUrl: value["managementUrl"],
    requirement: SoftwareRequirementToJSON(value["requirement"]),
    requiredTeams: (value["requiredTeams"] as Array<any>).map(
      SoftwareAudienceTeamToJSON,
    ),
  };
}
